
import { oget } from "@/utils";
/**
 * @fileOverview Array 扩展类
 * @author ZD @zd.com
 * @version 0.0.1
 */

Array.prototype.index = -1;
/**
 * @description 删除数组中某个元素
 * @param { Number } i
 */
Array.prototype.remove = function (i) {
    this.splice(i, 1);
}
/**
 * @description 删除数组中某个元素
 * @param { Number } i
 */
Array.prototype.removeBuyValue = function (v, path) {
    if (path) {
        let index = -1;
        this.find((vo, i) => {
            const value = oget(vo, path);
            if (value === v) {
                index = i;
                return true;
            }
        })
        this.splice(index, 1);
        return this;
    }
    const index = this.indexOf(v);
    if (index === -1) return this;
    this.splice(index, 1);
    return this;
}
/**
 * @description 获取数组中的最后一项
 * @param { Number } i
 */
Array.prototype.last = function () {
    return this[this.length - 1];
}
/**
 * @description 替换数组中某个元素
 * @param { Number } i
 * @param { Object } val
 */
Array.prototype.replace = function (i, val) {
    this.splice(i, 1, val);
}
/**
 * @description 在指定位置插入元素
 * @param { Number } i
 * @param { Object } val
 */
Array.prototype.insert = function (i, val) {
    this.splice(i, 0, val);
};
/**
 * @description 数组去重
 * @param { Array } arr
 * @returns { Array }
 */
Array.prototype.removeRepeat = function (arr) {
    return Array.from(new Set(arr));
}
/**
 * @description 判断数组是否还有值
 * @returns { Boolean }
 */
Array.prototype.hasNext = function () {
    return this.index < this.length - 1;
}
/**
 * @description 获取数组下一个值
 * @returns { * }
 */
Array.prototype.next = function () {
    this.index++;
    if (this.index == this.length) this.index = 0;
    const data = this[this.index];
    return data;
}
/**
 * @description 移动当前指向都下标
 * @returns { * }
 */
Array.prototype.move = function (index) {
    this.index = index;
}
/**
 * @description 判断当前下标是不是在最后一个
 * @returns { * }
 */
Array.prototype.onLast = function () {
    return this.length === (this.index + 1);
}
Array.prototype.sortAsc = function (field) {
    let arr = this;
    function compare(path) {
        return function (a, b) {
            var value1 = path ? oget(a, path) : a;
            var value2 = path ? oget(b, path) : b;
            return value1 - value2;
        }
    }
    return arr.sort(compare(field))
}
Array.prototype.sortDesc = function (field) {
    let arr = this;
    function compare(path) {
        return function (a, b) {
            var value1 = path ? oget(a, path) : a;
            var value2 = path ? oget(b, path) : b;
            return value2 - value1;
        }
    }
    return arr.sort(compare(field))
}
Array.prototype.mergeItem = function () {
    var arr = [];
    this.forEach(item => arr = arr.concat(item))
    return arr;
}
/**
* 将大数组拆分为小数组
* @param {Number} length 拆分后每组的长度
*/
Array.prototype.split = function (length) {
    var group = [];
    this.forEach(function (val, i) {
        var item = group[Math.floor(i / length)];
        return item ? item.push(val) : (item = [val]) & (group[Math.floor(i / length)] = item);
    })
    return group;
}